import React, { useState } from "react";
import { Star, ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/site";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];

  return (
    <section data-testid="testimonials-section" className="py-20 lg:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <div className="overline mb-4">Client Voices</div>
          <h2 className="section-heading text-navy text-3xl md:text-4xl lg:text-5xl font-bold">
            Trusted by importers in every major grocery market.
          </h2>
        </div>

        <div className="relative rounded-3xl bg-[#F7F9FC] p-8 lg:p-14 border border-slate-100">
          <Quote className="absolute top-8 left-8 w-16 h-16 text-emerald/10" />
          <div className="relative text-center max-w-3xl mx-auto">
            <div className="flex justify-center gap-1 mb-6">
              {Array.from({ length: 5 }).map((_, k) => (
                <Star key={k} className="w-4 h-4 fill-gold text-gold" />
              ))}
            </div>
            <blockquote className="font-display text-xl md:text-2xl lg:text-3xl text-navy leading-snug italic">
              "{t.quote}"
            </blockquote>
            <div className="mt-8">
              <div className="font-bold text-navy text-lg">{t.name}</div>
              <div className="text-sm text-slate-600 mt-1">
                {t.role} · {t.company}
              </div>
              <div className="text-xs uppercase tracking-widest text-emerald mt-2 font-semibold">
                {t.country}
              </div>
            </div>
          </div>

          <div className="mt-10 flex items-center justify-between">
            <div className="flex gap-2">
              {TESTIMONIALS.map((_, k) => (
                <button
                  key={k}
                  data-testid={`testimonial-dot-${k}`}
                  onClick={() => setI(k)}
                  aria-label={`Testimonial ${k + 1}`}
                  className={`h-2 rounded-full transition-all ${
                    i === k ? "w-8 bg-navy" : "w-2 bg-slate-300"
                  }`}
                />
              ))}
            </div>
            <div className="flex gap-2">
              <button
                data-testid="testimonial-prev"
                aria-label="Previous testimonial"
                onClick={() => setI((v) => (v - 1 + TESTIMONIALS.length) % TESTIMONIALS.length)}
                className="w-11 h-11 rounded-full bg-white border border-slate-200 flex items-center justify-center hover:bg-navy hover:text-white hover:border-navy transition-all"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <button
                data-testid="testimonial-next"
                aria-label="Next testimonial"
                onClick={() => setI((v) => (v + 1) % TESTIMONIALS.length)}
                className="w-11 h-11 rounded-full bg-white border border-slate-200 flex items-center justify-center hover:bg-navy hover:text-white hover:border-navy transition-all"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
